import { platformApiSlice } from "./platformApiSlice";

const normalizeActivityRunsResponse = (responseData) => {
  if (Array.isArray(responseData)) return responseData;
  if (responseData && Array.isArray(responseData.items)) return responseData.items;
  return [];
};

export const platformActivityApiSlice = platformApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Hub Activity list for a website (V2 activity_runs). Used by Staging/Prod
     * Agents to surface runs that never linked a V1 scan_id.
     */
    getPlatformActivityRuns: builder.query({
      query: ({ websiteId, useProd = false, pageSize = 100 }) => ({
        url: "/api/v2/activity-runs",
        params: {
          use_prod: useProd,
          page: 1,
          page_size: pageSize,
        },
        headers: websiteId ? { "X-Website-Id": websiteId } : undefined,
      }),
      transformResponse: normalizeActivityRunsResponse,
      providesTags: ["ActivityRuns"],
    }),
    /**
     * Hard-delete a V2 activity run (no V1 scan to cascade from). Requires
     * ``X-Website-Id`` — same tenant header as the list endpoint.
     */
    deletePlatformActivityRun: builder.mutation({
      query: ({ runId, websiteId, useProd = false }) => ({
        url: `/api/v2/activity-runs/${runId}`,
        method: "DELETE",
        params: { use_prod: useProd },
        headers: websiteId ? { "X-Website-Id": websiteId } : undefined,
      }),
      invalidatesTags: ["ActivityRuns", "Scans"],
    }),
  }),
});

export const {
  useGetPlatformActivityRunsQuery,
  useDeletePlatformActivityRunMutation,
} = platformActivityApiSlice;
